import loadSagas from "./load";

export const resourceSagas = [
	...loadSagas
];

export default resourceSagas;
